<!-- 新增笔记 -->
<template>
  <div class="add-notes">
    <div class="input-content">
      <x-textarea :max="500" v-model="addNote.noteText" class="input-content__textarea" :rows='3' show-counter placeholder="记录下客户接待内容吧，笔记照片最多3张"></x-textarea>
      <upload-images v-model="addNote.noteImages" class="upload-images"></upload-images>
    </div>
    <group class="add-notes__select">
      <Datetime
        v-model="addNote.nextFollowAt"
        title='跟进时间'
        confirm-text='确认'
        cancel-text='取消'
        placeholder="请选择"
        format='YYYY-MM-DD HH:mm'
        year-row="{value}年"
        month-row="{value}月"
        day-row="{value}日"
        hour-row="{value}点"
        minute-row="{value}分"
        :minute-list="['00', '30']"
        :start-date="dateStart"
        @on-change='handleChangeTime'
      >
      </Datetime>
    </group>
    <group class="add-notes__select">
      <selector title='笔记类型' :readonly="disabledNoteType" placeholder="请选择" v-model="addNote.noteType" :options="noteTypes"></selector>
    </group>
    <footer-btn title="保存" @submit="handleSubmit"></footer-btn>
  </div>
</template>

<script>
import {
  XTextarea,
  group,
  selector,
  Datetime
} from '@lx-frontend/cvux'
import FooterBtn from '../components/FooterBtn'
import UploadImages from '../components/UploadImages'
import { noteTypes } from '../../common/professionalData'
import util from '../../common/util'
export default {
  components: {
    XTextarea,
    FooterBtn,
    UploadImages,
    selector,
    group,
    Datetime
  },
  data() {
    return {
      addNote: {
        noteText: '',
        noteImages: [],
        noteType: '',
        nextFollowAt: '',
        addType: ''// 保存类型  是补充笔记  还是新增笔记
      },
      id: '', // 这个可能是客户id 也可能是笔记id
      disabledNoteType: false,
      noteTypes,
      isSubmit: false,
      dateStart: null
    }
  },
  created() {
    this.dateStart = util.formatTime(new Date(), 'yyyy-MM-dd')
    this.addNote.addType = this.$route.query.type
    this.id = this.$route.query.id
    if (this.addNote.addType === 'edit') {
      this.disabledNoteType = true
      this.addNote.noteType = 1 // 默认到店接待
    }
  },
  mounted() {
    const { addType } = this.addNote
    const title = addType === 'edit' ? '补充笔记' : '添加笔记'
    util.changeTitle(title)
  },
  methods: {
    //  文本或者图片 2选1 必填 图片最多三张
    // 下次跟进时间（非必填） 笔记类型必填
    // 如果是补充笔记类型，则默认选择到店接待，并且不可修改
    handleSubmit() {
      if (!this.validFormat(this.addNote)) return
      if (this.isSubmit) return
      const { noteText, noteImages, noteType, nextFollowAt, addType } = this.addNote
      const { id } = this
      const body = {
        note: noteText,
        images: noteImages,
        note_type: noteType,
        next_follow_at: this.formatTime(nextFollowAt)
      }
      !nextFollowAt && delete body.next_follow_at
      this.addNote.addType === 'edit' ? this.editNoteSubmit(id, body) : this.addNoteSubmit(id, body)
    },
    async editNoteSubmit(noteId, body) {
      this.isSubmit = true
      const res = await this.$rest.carRegister.editSaleNote(noteId)(body)
      this.isSubmit = false
      if (res.code !== 0) {
        this.$message.fail(res.message || '未知错误')
        return
      }
      this.$message.success('补充笔记成功', this.runBack)
    },
    async addNoteSubmit(customerId, body) {
      this.isSubmit = true
      const res = await this.$rest.carRegister.addSaleNote(customerId)(body)
      this.isSubmit = false
      if (res.code !== 0) {
        this.$message.fail(res.message || '未知错误')
        return
      }
      this.$message.success('新增笔记成功', this.runBack)
    },
    validFormat(addNote) {
      const { noteText, noteImages, noteType } = addNote
      if (!noteText && !noteImages.length) {
        this.$message.fail('文本或者图片至少二选一填写！')
        return false
      }
      if (!noteType) {
        this.$message.fail('请选择笔记类型！')
        return false
      }
      return true
    },
    handleChangeTime(time) {
      const nowTime = util.formatTime(new Date(), 'yyyy-MM-dd hh:mm')
      if (util.diffTime(time, nowTime) <= 0) {
        this.$message.fail('跟进时间早于当前时间，请重试')
        this.$nextTick(() => {
          this.addNote.nextFollowAt = ''
        })
      }
    },
    formatTime(time) {
      if (time) return `${time}:00`
      else return null
    }
  }
}
</script>
<style lang='less' scoped>
@import url('../../stylesheets/base/fn.less');
@w2: 75rem;
.add-notes {
  .input-content {
    width: 100%;
    min-height: 430 / @w2;
    background-color: #fff;
    box-sizing: border-box;
    padding: 30 / @w2;
    position: relative;
    &__textarea {
      height: 180 / @w2;
      line-height: 60 / @w2;
    }
    /deep/ .weui_cell {
      padding: 0;
      textarea::-webkit-input-placeholder {
        font-size: 28 / @w2;
        color: #c9c9c9;
      }
    }
    .upload-images {
      position: absolute;
      left: 30 / @w2;
      bottom: 30 / @w2;
    }
  }
  &__select {
    margin-bottom: 18 / @w2;
    /deep/ .weui_cell_bd {
      width: 180 / @w2;
      display: inline-block;
      padding-right: 10 / @w2;
    }
  }
}
</style>
